import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';

import GLOBAL_MANUFACTURER_HARVEST_TAGS from 'lib/enums/GlobalManufacturerHarvestTags';
import HarvestStatWidget from 'components/manage_manufacturers/global_manufacturer_harvest/HarvestStatWidget';
import {
  softIndigo,
  softIndigoDark,
  softPurple,
  softPurpleDark,
  softBlue,
  softBlueDark,
  softTealPrimary,
  softGreen,
  softGreenDark,
  softTeal,
  softAmber,
  softAmberDark,
} from 'lib/css/colors';

const WIDGET_CONFIGS = [
  {
    key: 'total',
    label: 'Total Manufacturers',
    gradient: `linear-gradient(135deg, ${softIndigo} 0%, ${softIndigoDark} 100%)`,
    dataKey: 'total_manufacturers',
    subtext: 'of total',
  },
  {
    key: 'gmv_manufacturer',
    label: 'Manufacturers with GMV',
    gradient: `linear-gradient(135deg, ${softGreen} 0%, ${softGreenDark} 100%)`,
    dataKey: 'gmv_manufacturer_count',
    subtext: 'on harvest table',
  },
  {
    key: 'manufacturer_url',
    label: 'Manufacturers with URL',
    gradient: `linear-gradient(135deg, ${softAmber} 0%, ${softAmberDark} 100%)`,
    dataKey: 'manufacturer_url_count',
    subtext: 'have a URL',
  },
  {
    key: 'gdsn',
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.GDSN,
    gradient: `linear-gradient(135deg, ${softPurple} 0%, ${softPurpleDark} 100%)`,
    dataKey: 'gdsn_count',
    subtext: 'of total',
  },
  {
    key: 'supplier_portal',
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.SUPPLIER_PORTAL,
    gradient: `linear-gradient(135deg, ${softBlue} 0%, ${softBlueDark} 100%)`,
    dataKey: 'supplier_portal_count',
    subtext: 'of total',
  },
  {
    key: 'scraped',
    label: GLOBAL_MANUFACTURER_HARVEST_TAGS.SCRAPED,
    gradient: `linear-gradient(135deg, ${softTealPrimary} 0%, ${softTeal} 100%)`,
    dataKey: 'scraped_count',
    subtext: 'of total',
  },
];

function WidgetHeader({ stats = {}, loading = false }) {
  return (
    <div className={css(styles.container)}>
      <Row>
        {WIDGET_CONFIGS.map(config => (
          <Col key={config.key} xs={12} sm={6} lg={4} xl={2} className="mb-3">
            <HarvestStatWidget
              label={config.label}
              count={stats[config.dataKey]}
              subtext={config.subtext}
              gradient={config.gradient}
              loading={loading}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
  },
});

WidgetHeader.propTypes = {
  stats: PropTypes.shape({
    total_manufacturers: PropTypes.number,
    gdsn_count: PropTypes.number,
    supplier_portal_count: PropTypes.number,
    scraped_count: PropTypes.number,
    no_data_count: PropTypes.number,
    gmv_manufacturer_count: PropTypes.number,
    manufacturer_url_count: PropTypes.number,
  }),
  loading: PropTypes.bool,
};

export default WidgetHeader;
